<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" size="small" v-if="form.headImgUrl" :src="form.headImgUrl"></el-avatar>
              <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box">
                <p>{{ form.nickName }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">{{ form.mobile ? '手机号码:' : '身份证号码:'}} {{ form.mobile ? form.mobile : form.idCardNo}}</p>
                  <p>可用余额: <span class="fontSize18">￥{{ form.walletAmount }}</span></p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="head-img">
            <div class="head_avater flex-row">
                <div class="top-img">
                  <img :src="form.headImgUrl ? form.headImgUrl : headImgUrl" alt="" style="width: 50px;height: 50px;border-radius: 50%;">
                </div>
                <div class="ml10">
                    <div class="mb10">{{form.nickName}}</div>
                    <div class="flex-row">
                      <div class="color666">{{form.mobile ? form.mobile : form.idCardNo}}</div>
                      <div class="color666 ml30">可用余额： <span class="moneys">￥{{form.walletAmount}}</span></div>
                    </div>
                </div>
              </div>
            </div> -->
            <p class="order-title-boxs"><span class="blueBlock"></span><i>免密设置</i></p>
            <div class="totals-box pl24">
              <div class="flex-row mb30" v-if="form.mobile">
                <div class="itemName">手机号码</div>
                <div class="itemNum">{{ form.mobile }}</div>
              </div>
			  <div class="flex-row mb30" v-if="!form.mobile">
			    <div class="itemName">身份证号</div>
			    <div class="itemNum">{{ form.idCardNo }}</div>
			  </div>
              <div class="flex-row mb30">
                <div class="itemName">小额免密支付</div>
                <div class="itemNum">{{ form.discountAmount }}<el-switch class="byPassButton switchBtn" active-value='on' inactive-value="off"  v-model="form.tradeNoPwdFlag"></el-switch><span class="ml20">开启后支付时无需输入密码</span></div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">免密额度</div>
                <div class="moneys">￥{{ form.tradeNoPwdAmount }}</div>
              </div>
            </div>
        </div>
        <div class="tips_position">
          <tips :type="'tradeNoPwd'" ></tips>
        </div>
        
        <div class="drawer-footer pb10 pr24">
          <el-button @click="back">取消</el-button>
          <div class="btns">
            <el-button type="primary" class="ml10" @click="onSubmit">确定</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import { decrypt, encrypt } from "../../assets/javascript/untils";
import tips from "../../components/tips";
export default {
  mixins: [minxin],
  components: { drawer ,tips},
  data() {
    return {
      codeName: true,
      time: 60,
      addEditTitle: "小额免密",
      addEditShow: false,
      form: {
        memberId: "",
        mobile: ""
      },
      columns: [],
      staffList: [],
      cardOldName: "",
      tradeNoPwdFlag: "",
      headerImg: require("../../assets/images/headerImg.png"),
      showPicker: false,
      toggleFlag: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.$refs['form'].resetFields()
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.form.memberId = org.id;
        this.$api.get(this.$url.member.get, {
              id: org.id
            }).then(res => {
              if (res) {
                this.addEditShow = true;
                this.form = res;
                this.form.memberId = res.id;
                this.tradeNoPwdFlag = this.form.tradeNoPwdFlag;
                localStorage.removeItem("tradeNoPwdFlag");
              }
            })
            .catch(error => {});
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    addLoginCode() {
      if (this.form.mobile == "") {
        this.$message.error("请输入手机号码");
        return false;
      }
      if (this.form.mobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
        return false;
      }
      let arr = encrypt(
        JSON.stringify({
          mobile: this.form.mobile,
          bizType: "memberTradeNoPwd",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        if (resp) {
          this.$message.success("短信发送成功")
          this.codeName = false;
        } else {
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    onSubmit(values) {
        if (this.form.tradeNoPwdFlag && this.tradeNoPwdFlag == this.form.tradeNoPwdFlag && this.form.tradeNoPwdFlag == 'on') {
           return this.$message.info("免密功能已是开启状态");
        } else if (this.form.tradeNoPwdFlag && this.tradeNoPwdFlag == this.form.tradeNoPwdFlag && this.form.tradeNoPwdFlag == 'off') {
           return this.$message.info("免密功能已是关闭状态");
        } 
        
        if (this.form.tradeNoPwdFlag == 'on') {
          this.$confirm('开通后，小额付款订单可支持自动免密扣款。确定开通?', '提示', {
              confirmButtonText: '开通免密支付',
              cancelButtonText: '取消操作',
              type: 'warning',
              center: true
          }).then(() => {
            this.$api.post(this.$url.member.updateTradeSecret, this.form).then(res => {
                if (res) {
                  this.addEditShow = false;
                  this.$message.success("操作成功");
                  this.$emit("change", true);
                } else {
                  console.log(1);
                }
            })
          }).catch(() => {
              
          });
        } else {
            this.$confirm('关闭后，支付订单将不再自动免密扣款。确定关闭?', '提示', {
                confirmButtonText: '关闭免密支付',
                cancelButtonText: '取消操作',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.post(this.$url.member.updateTradeSecret, this.form).then(res => {
                    if (res) {
                        this.addEditShow = false;
                        this.$message.success("操作成功");
                        this.$emit("change", true);
                    }
                })
            }).catch(() => {
                
            });
        }
        
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ .el-input__suffix {
    line-height: 40px;
}
.tips_position {
  position: absolute;
  bottom: 80px;
  border-radius: 4px;
}
.pay-mains {
  .member-msg {
    padding: 16px 16px 0;
    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;
      .member-box {
        margin-left: 10px;
        .mobile {
          line-height: 1.6;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>